import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "jasbwgDetail"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($data.detail.name), 1), _createElementVNode("img", {
    src: $data.detail.img
  }, null, 8, _hoisted_3), _createElementVNode("div", {
    innerHTML: $data.detail.content,
    class: "content"
  }, null, 8, _hoisted_4)]);
}